import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';
import { LocalizedText } from 'bernie-l10n';

import { MultiItemStore } from 'stores/multi-item-store';

import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkPageLoader } from 'uitk-react-loader';
import { UitkSecondaryFloatingButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkToast } from 'uitk-react-toast';

export interface MapSearchProps {
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  messageDismissed: () => void;
  searchInProgress?: boolean;
  searchMessage?: string;
  showSearchButton?: boolean;
  center?: any;
  multiItem?: MultiItemStore;
}

export interface MapSearchState {
  center?: any;
}

@inject('routeStore', 'analytics', 'multiItem')
@observer
export class MapSearch extends React.Component<MapSearchProps, MapSearchState> {
  private trackMapSearch: () => void;

  public constructor(props) {
    super(props);
    this.setUpAnalyticsTrackers(props.analytics);

    this.onMapSearch = this.onMapSearch.bind(this);
  }

  public render() {
    const { messageDismissed, searchInProgress, searchMessage, showSearchButton, multiItem } = this.props;
    const isMultiItem = multiItem && multiItem.isPackageShoppingPath();

    return (
      <>
        {(showSearchButton || searchInProgress) && !isMultiItem && (
          <UitkLayoutPosition type="absolute" position={{ top: 'twelve', left: 'center', zindex: 'layer2' }} cloneElement={true}>
            <UitkSpacing margin={{ blockstart: 'twelve' }}>
              <UitkSecondaryFloatingButton className="elevation-4" disabled={searchInProgress} onClick={this.onMapSearch}>
                <LocalizedText message="maps.viewer.searchButton.text" />
              </UitkSecondaryFloatingButton>
            </UitkSpacing>
          </UitkLayoutPosition>
        )}
        <UitkLayoutPosition type="absolute" position={{ top: 'center', left: 'center', zindex: 'layer7' }} cloneElement={true}>
          <UitkPageLoader visible={searchInProgress} />
        </UitkLayoutPosition>
        <UitkToast show={Boolean(searchMessage)} onDismiss={messageDismissed}>
          {searchMessage}
        </UitkToast>
      </>
    );
  }

  private setUpAnalyticsTrackers(analytics) {
    const noop = () => null;
    let clickTracker;
    if (analytics && analytics.clickTracker) {
      clickTracker = analytics.clickTracker.bind(analytics);
      this.trackMapSearch = clickTracker('Module.Map.Search.Button', 'User clicking the map search button on PWA HSR Map', null, noop);
    } else {
      this.trackMapSearch = noop;
    }
  }

  private onMapSearch() {
    this.trackMapSearch();
    const { center } = this.props;
    const latLong = `${center.lat()},${center.lng()}`;
    this.props.routeStore.updateSearch({
      regionId: '',
      destination: '',
      selected: '',
      poi: '',
      latLong,
    });
  }
}
